import { render, staticRenderFns } from "./FlussiListPage.vue?vue&type=template&id=39ba31be"
import script from "./FlussiListPage.vue?vue&type=script&lang=js"
export * from "./FlussiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports